<template>
	<v-container class="outreach none-fluid link">
		<banner>Mentoring Advice</banner>
		<div class="mx-auto container">
			<div>
				<div>
					<img style="width:37%;margin-top:5px;margin-right:20px;margin-bottom:10px;float:left;" :src="image" alt="Presidential Award for Excellence in Science, Mathematics, and Engineering Menoring">
					<div v-html="$sanitize(content)"></div>
				</div>
			</div><!-- /.container -->
		</div>
	</v-container>
</template>

<script>
import Banner from "../global/Banner";
import { getMentoring } from "../../service/outreach/mentoring";

export default {
	components: {
		Banner
	},
	data() {
		return {
			content: {},
			image: {}
		};
	},
	mounted() {
		getMentoring()
			.then(data => {
				console.log(data)
				this.content = data.content,
				this.image = data.image
				
			})
			.catch(err => {
				console.error(err.message);
			});
	}
};
</script>

<style>
  @import '../../css/sub.css';
</style>